<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="management-teachers-table"
            :fields="fields"
            :items="selectedTeachers">
            <template #options>
                <b-button
                    class="btn-add btn-add-teacher"
                    v-b-modal.management-profile-teachers-add-modal
                    variant="primary">
                    {{ $t('management.add_administrator') }}
                </b-button>
            </template>

            <template v-slot:cell(actions)="row">
                <b-button
                    class="btn-remove btn-remove-teacher"
                    v-b-tooltip.hover
                    variant="danger-icon-only"
                    @click="removeTeacher(row.item)"
                    :title="$t('common.delete')">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>
        <design-2021-management-profile-add-teacher-component
            :teachers-in="availableTeachers"
            @selected-teacher="storeTeacher">
        </design-2021-management-profile-add-teacher-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-management-profile-management-component',
    props: {
        teachersIn: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            teachers: this.teachersIn,
            fields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },

    methods: {
        changeTeacher(event, teacher) {
            if (event) {
                this.storeTeacher(teacher);
            } else {
                this.removeTeacher(teacher);
            }
        },

        storeTeacher(teacher) {
            let data = {
                user_id: teacher.id,
            };

            this.axios.post(this.routes.profileManagementAddTeacher(), data).then(
                (response) => {
                    teacher.roles = [response.data];
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        removeTeacher(teacher) {
            this.alert
                .confirm(
                    this.$t('management.withdraw_rights'),
                    this.$t('management.are_you_sure_you_want_to_withdraw_the_rights_for_this_teacher'),
                    this.$t('management.yes_withdraw'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.axios.delete(this.routes.profileManagementDeleteTeacher(teacher.id)).then(
                        (response) => {
                            teacher.roles = [];
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
    },

    computed: {
        availableTeachers() {
            if (!this.teachersIn.length === 0) {
                return [];
            }
            return this.teachersIn.filter((teacher) => teacher.roles.length === 0);
        },

        selectedTeachers() {
            if (!this.teachersIn.length === 0) {
                return [];
            }
            return this.teachersIn.filter((teacher) => teacher.roles.length > 0);
        },
    },
};
</script>

<style scoped lang="scss">
@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .management-teachers-table ::v-deep {
        .apprentice-table-header {
            flex-direction: row;

            .apprentice-table-filters {
                flex: 1 0 auto;
                margin-bottom: 0;
            }

            .apprentice-data-table-actions {
                justify-content: flex-end;
                flex: 1 0 auto;
            }
        }
    }
}
</style>
